import { Injectable } from '@angular/core';

import { MapContextLayer } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class ContextLayersUtilityService {
    constructor() { }

    sortByOrderDescending(contextLayers: MapContextLayer[]): MapContextLayer[] {
        return Array.from(contextLayers.sort((a, b) => {
            if (a.order === b.order) {
                return b.id.localeCompare(a.id);
            }

            return b.order - a.order;
        }));
    }

    castContextLayers(contextLayers: MapContextLayer[]): MapContextLayer[] {
        const castedLayers: MapContextLayer[] = [];
        contextLayers.forEach(layer => {
            const castedLayer = Object.assign(new MapContextLayer(), layer);
            castedLayers.push(castedLayer);
        });
        return castedLayers;
    }

    castContextLayer(contextLayer: MapContextLayer): MapContextLayer {
        return Object.assign(new MapContextLayer(), contextLayer);
    }
}
